module.exports = __webpack_public_path__ + "img/cheerful_msg.e7f7af1f.png";